// Vendor.
import $ from 'jquery';
import { TweenMax, Power2 } from 'gsap';
import 'gsap/ScrollToPlugin';
import Helpers from 'helpers/util';

// Modules
import Fields from '../modules/fields';
import AutocompleteAddress from '../modules/autocomplete-address';
import PharmacyLookup from './PharmacyLookup';

// Elements
let $el = $('.js-form');
let $headerDesktop = $('.nav-desktop');
let $headerMobile = $('.nav-mobile');

let $stepForm = $('.js-form-step');

// Form Field
class Form {
	constructor($el) {
		this.$el = $el;
		this.$fields = $el.find('.js-field');
		this.$autocomplete = $el.find('.js-address');
		this.$addressForm = $el.find('.js-address-form');
		this.$selectAll = $el.find('.js-field-select-all');
		this.$pharmacyLookup = $el.find('.js-pharmacy-lookup');
		this.scrollTopOnError = this.$el.data('scroll-top-on-error');
		this.pharmacyLookupInstances = [];
		this.validateFields = [];
		this.autoComplete = false;
		this.data = {};
		this.lastStep = false;

		this.setupFields();
		this.attachEvents();
		this.checkFormSearchFilled();
	}

	setupFields() {
		const $dateFields = this.$el.find('.field-date-picker');

		if (window.Datepicker) {
			$dateFields.each((i, $dateField) => {
				new window.Datepicker($dateField, {
					format: 'dd/mm/yyyy',
					nextArrow: '<span class="icon icon-chevron-right"></span>',
					prevArrow: '<span class="icon icon-chevron-left"></span>',
					beforeShowDay: (date) => {
						const currentDate = new Date();
						const calendarDate = new Date(date);

						if (currentDate.getMonth() === calendarDate.getMonth()) {
							return {
								classes: 'current-month',
							};
						}
					},
					// ...options
				});

				$($dateField)
					.siblings('.icon-calendar')
					.click(() => {
						$dateField.focus();
					});
			});
		}
	}

	onSubmit(currStep) {
		var isValid = true;

		if (currStep) {
			// only for step form
			const $fieldsCurrStep = currStep.find('.js-field');
			let validateFieldsStep = [];

			$fieldsCurrStep.each((i, el) => {
				validateFieldsStep[i] = new Fields(el);
			});

			$.each(validateFieldsStep, (i, v) => {
				v.onSubmit();

				if (!v.isValid) {
					isValid = false;
				} else {
					this.storeData(v.$el);
				}
			});
		} else {
			// all other forms
			$.each(this.validateFields, (i, v) => {
				v.onSubmit();

				if (!v.isValid) {
					isValid = false;
				}
			});
		}

		const $captcha = this.$el.find('.g-recaptcha');
		const $allCaptcha = $('.g-recaptcha');

		if ($captcha.length > 0) {
			if (isValid) {
				let response = window.grecaptcha.getResponse(
					$allCaptcha.index($captcha)
				);
				const clsError = 'error';
				if (
					response === '' ||
					response === undefined ||
					response.length === 0
				) {
					isValid = false;
					if (!$captcha.hasClass(clsError)) {
						$captcha.addClass(clsError);
					}
				} else {
					$captcha.removeClass(clsError);
					isValid = true;
				}
			}
		}

		return isValid;
	}

	storeData(input) {
		let $inputEl = input.find('.field-input');

		if ($inputEl.length > 0) {
			let inputEl = $inputEl.get(0);

			if ($inputEl.hasClass('js-address')) {
				this.data['field_primary_practice_address'] = inputEl.value;
			} else {
				this.data[inputEl.getAttribute('name')] = inputEl.value;
			}
		}
	}

	handlerSteps() {
		const $formStepsContainer = $('.register-steps');
		const $nexStepCTA = $formStepsContainer.find('.js-button-next');
		const $prevStepCTA = $formStepsContainer.find('.js-button-prev');
		const clsActive = 'is-active';
		this.nrCurrStep = 0;

		const logTabInGA = () => {
			const currentTab = this.nrCurrStep + 1;
			Helpers.pubsub.publish('GAEvent', {
				gaType: `onboarding_step_${currentTab}`,
			});
		};

		logTabInGA();

		const currentIndexStep = (dir) => {
			if (dir === 'forward') {
				this.nrCurrStep++;
			} else {
				this.nrCurrStep--;
			}

			return this.nrCurrStep;
		};

		const changeTab = (posStep, nrCurrStep) => {
			$stepForm.removeClass(clsActive);
			$stepForm.eq(nrCurrStep).addClass(clsActive);
			const $statusItem = $('.register-progress-status-item');
			const $currentItem = $('.register-progress-title-current');
			$statusItem.eq(nrCurrStep).addClass(clsActive);
			if ($statusItem.eq(nrCurrStep + 1).hasClass(clsActive)) {
				$statusItem.eq(nrCurrStep + 1).removeClass(clsActive);
			}
			$currentItem.text(posStep);
			logTabInGA();
		};

		const moveTab = (dir) => {
			const currStep = currentIndexStep(dir);
			const posStep = currStep + 1;
			//change tab
			changeTab(posStep, currStep);
		};

		const showErrorAhpra = (errorTxt) => {
			const $ahpraField = $formStepsContainer.find('.field-ahpra');
			const $error = $ahpraField.find('.field-error');
			const clsError = 'has-error';
			const clsVisible = 'is-visible';

			$ahpraField.addClass(clsError);
			$error.html(errorTxt);
			$error.addClass(clsVisible);
		};

		const ajaxCall = () => {
			// if( this.nrCurrStep === $stepForm.length - 1) {
			// token input hidden value
			let token = $formStepsContainer.find("input[name='form_token']").val();

			// newsletter check
			const $newsletterCheck = $formStepsContainer.find('#agree-updates');
			if ($newsletterCheck && $newsletterCheck.is(':checked')) {
				this.data['newsletter'] = 1;
			}

			//ajax call;
			$.ajax({
				url: '/api/register',
				data: JSON.stringify(this.data),
				type: 'POST',
				headers: {
					'X-CSRF-Token': token,
				},
				dataType: 'json',
				contentType: 'application/json',
				success: (data) => {
					if (data.success) {
						Helpers.pubsub.publish('GAEvent', {
							gaType: 'onboarding_submit',
						});
						window.setTimeout(() => {
							window.location.href = '/';
						}, 0);
					} else {
						if (data.error.field_ahpra_registration_number) {
							moveTab('backward');
							showErrorAhpra(data.error.field_ahpra_registration_number);
						} else {
							Object.keys(data.error).forEach(function (key) {
								const value = data.error[key];
								$formStepsContainer
									.find('.generic-error')
									.append(`<p>${value}</p>`);
							});
						}
					}
				},
				error: (request, error) => {
					$formStepsContainer.find('.generic-error').append(`<p>${error}</p>`);
				},
			});

			// }
		};

		const nextStep = () => {
			// Scroll window to top after moving to next step
			TweenMax.to(window, 0.5, { scrollTo: { y: 0 } });

			if (this.nrCurrStep < $stepForm.length - 1) {
				// it's not the last step > move on
				moveTab('forward');
			} else {
				// last step > send form
				ajaxCall();
			}
		};

		// Click events
		$nexStepCTA.on('click', (e) => {
			const $currStepForm = $(e.currentTarget).parents('.js-form-step');
			const tabIsValid = this.onSubmit($currStepForm);
			if (!tabIsValid) {
				this.scrollToError();
			} else {
				nextStep();
				if (this.autoComplete) {
					this.autoComplete.prepareForSubmit();
				}
			}
			return tabIsValid;
		});

		$prevStepCTA.on('click', () => {
			moveTab('backward');
		});
	}

	attachEvents() {
		this.$el.on('submit', (e) => {
			const isFormValid = this.onSubmit();
			if (!isFormValid) {
				if (this.scrollTopOnError) {
					let error = this.$el.find('.global-form-error')[0];
					if (!error) {
						this.$el.prepend(`
							<p class="global-form-error">
								*Sorry one or more required fields are empty, please check that all required fields are completed and try again.
							</p>
						`);
						error = this.$el.find('.global-form-error');
					}
					TweenMax.to(window, 1, {
						scrollTo: { y: error },
						ease: Power2.easeInOut,
					});
				} else {
					this.scrollToError();
				}
			} else {
				const error = this.$el.find('.global-form-error')[0];
				if (error) {
					$(error).remove();
				}
				Helpers.pubsub.publish('GAEvent', {
					event: e,
					gaType: e.target.getAttribute('data-ga'),
				});
				if (this.autoComplete) {
					this.autoComplete.prepareForSubmit();
				}
				this.pharmacyLookupInstances.forEach((i) => i.prepareForSubmit());
			}
			return isFormValid;
		});

		if (this.$el.is($stepForm) && this.$el.hasClass('is-active')) {
			this.handlerSteps();
		}

		this.$fields.each((i, el) => {
			this.validateFields[i] = new Fields(el);
		});

		if (this.$autocomplete.length && this.$addressForm.length) {
			this.autoComplete = new AutocompleteAddress(
				this.$autocomplete,
				this.$addressForm
			);
		}

		if (this.$pharmacyLookup.length) {
			this.$pharmacyLookup.each((index, element) => {
				this.pharmacyLookupInstances.push(new PharmacyLookup(element));
			});
		}

		let iWantSubmit = true;

		this.$fields.find('input').on('keydown', (e) => {
			if (e.keyCode === 13) {
				e.preventDefault();

				//disable enter only for this form
				if (this.$el.is('.user-onboarding-form')) {
					return false;
				}

				//first enter fill the address so set iWantSubmit false
				if ($(e.currentTarget).is('.js-address')) {
					iWantSubmit = !iWantSubmit;
				}

				//now I can submit the form
				if (this.onSubmit() && iWantSubmit) {
					this.$el.submit();
				}
			}
		});
	}

	checkFormSearchFilled() {
		const $searchCont = $('.search-popout, .nav-search');

		if ($searchCont.length > 0) {
			const $inputSearch = $searchCont.find('input');

			$inputSearch.on('keyup', (e) => {
				const el = e.currentTarget;
				const $form = $(e.currentTarget).parents('form');
				const $button = $form.find('button');

				if (el.value === '') {
					$button.attr('disabled', 'disabled');
				} else {
					$button.removeAttr('disabled');

					if (e.which === 13) {
						$form.submit();
					}
				}
			});
		}
	}

	scrollToError() {
		if (!$headerDesktop.length) {
			return false;
		}
		let $target = this.$fields.filter('.has-error').eq(0);
		let offset =
			window.innerWidth > 1024
				? $headerDesktop.outerHeight()
				: $headerMobile.outerHeight();
		let y = $target.offset().top - (offset + 10);

		TweenMax.to($(window), 0.5, { scrollTo: { y: y } });
	}
}

const _init = () => {
	if ($el.length) {
		$el.each((e, v) => {
			new Form($(v));
		});
	}

	if ($stepForm.length) {
		$stepForm.each((i, v) => {
			new Form($(v));
		});
	}
};

_init();
